// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Or$OrcaPaymentPage from "./Components/Or.bs.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Icon$OrcaPaymentPage from "./Icon.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as GPayLazy$OrcaPaymentPage from "./Payments/GPayLazy.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as PoweredBy$OrcaPaymentPage from "./Components/PoweredBy.bs.js";
import * as BoletoLazy$OrcaPaymentPage from "./Payments/BoletoLazy.bs.js";
import * as ErrorUtils$OrcaPaymentPage from "./Utilities/ErrorUtils.bs.js";
import * as PayPalLazy$OrcaPaymentPage from "./Payments/PayPalLazy.bs.js";
import * as CardPayment$OrcaPaymentPage from "./Payments/CardPayment.bs.js";
import * as ConfirmType$OrcaPaymentPage from "./Types/ConfirmType.bs.js";
import * as PaymentType$OrcaPaymentPage from "./Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as ApplePayLazy$OrcaPaymentPage from "./Payments/ApplePayLazy.bs.js";
import * as PayNowButton$OrcaPaymentPage from "./Components/PayNowButton.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as SavedMethods$OrcaPaymentPage from "./Components/SavedMethods.bs.js";
import * as SessionsType$OrcaPaymentPage from "./Types/SessionsType.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./hyper-log-catcher/ErrorBoundary.bs.js";
import * as PayPalHelpers$OrcaPaymentPage from "./Payments/PayPalHelpers.bs.js";
import * as ClickToPayHook$OrcaPaymentPage from "./Hooks/ClickToPayHook.bs.js";
import * as PaymentOptions$OrcaPaymentPage from "./PaymentOptions.bs.js";
import * as PaymentModeType$OrcaPaymentPage from "./Types/PaymentModeType.bs.js";
import * as ACHBankDebitLazy$OrcaPaymentPage from "./Payments/ACHBankDebitLazy.bs.js";
import * as SwitchViewButton$OrcaPaymentPage from "./Components/SwitchViewButton.bs.js";
import * as BacsBankDebitLazy$OrcaPaymentPage from "./Payments/BacsBankDebitLazy.bs.js";
import * as BecsBankDebitLazy$OrcaPaymentPage from "./Payments/BecsBankDebitLazy.bs.js";
import * as SepaBankDebitLazy$OrcaPaymentPage from "./Payments/SepaBankDebitLazy.bs.js";
import * as AccordionContainer$OrcaPaymentPage from "./Components/AccordionContainer.bs.js";
import * as ACHBankTransferLazy$OrcaPaymentPage from "./Payments/ACHBankTransferLazy.bs.js";
import * as BacsBankTransferLazy$OrcaPaymentPage from "./Payments/BacsBankTransferLazy.bs.js";
import * as LoaderPaymentShimmer$OrcaPaymentPage from "./Components/LoaderPaymentShimmer.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./Payments/PaymentMethodsRecord.bs.js";
import * as SepaBankTransferLazy$OrcaPaymentPage from "./Payments/SepaBankTransferLazy.bs.js";
import * as PaymentElementShimmer$OrcaPaymentPage from "./Components/PaymentElementShimmer.bs.js";
import * as ReusableReactSuspense$OrcaPaymentPage from "./hyper-log-catcher/ReusableReactSuspense.bs.js";
import * as SessionPaymentWrapper$OrcaPaymentPage from "./Components/SessionPaymentWrapper.bs.js";
import * as InstantBankTransferLazy$OrcaPaymentPage from "./Payments/InstantBankTransferLazy.bs.js";
import * as PaymentMethodsWrapperLazy$OrcaPaymentPage from "./Payments/PaymentMethodsWrapperLazy.bs.js";
import * as PaymentRequestButtonElement$OrcaPaymentPage from "./Payments/PaymentRequestButtonElement.bs.js";
import * as SavedMethodsWithPaymentForm$OrcaPaymentPage from "./Payments/SavedMethodsWithPaymentForm.bs.js";
import * as InstantBankTransferPolandLazy$OrcaPaymentPage from "./Payments/InstantBankTransferPolandLazy.bs.js";
import * as InstantBankTransferFinlandLazy$OrcaPaymentPage from "./Payments/InstantBankTransferFinlandLazy.bs.js";

function cardsToRender(width) {
  return (width - 40 | 0) / 130 | 0;
}

function PaymentElement(props) {
  var paymentType = props.paymentType;
  var cvcProps = props.cvcProps;
  var expiryProps = props.expiryProps;
  var cardProps = props.cardProps;
  var divRef = React.useRef(null);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var displaySavedPaymentMethods = match.displaySavedPaymentMethods;
  var paymentMethodOrder = match.paymentMethodOrder;
  var customerPaymentMethods = match.customerPaymentMethods;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var optionAtomValue = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var isApplePayReady = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isApplePayReady);
  var isGPayReady = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isGooglePayReady);
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var isShowOrPayUsing = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isShowOrPayUsing);
  var isShowOrPayUsingWhileLoading = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isShowOrPayUsingWhileLoading);
  var match$2 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var clickToPayConfig = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.clickToPayConfig);
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var setSelectedOption = match$3[1];
  var selectedOption = match$3[0];
  var match$4 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var setShowPaymentMethodsScreen = match$4[1];
  var showPaymentMethodsScreen = match$4[0];
  var match$5 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.paymentTokenAtom);
  var setPaymentToken = match$5[1];
  var paymentToken = match$5[0];
  var match$6 = Recoil.useRecoilState(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var setPaymentMethodListValue = match$6[1];
  var paymentMethodListValue = match$6[0];
  var match$7 = React.useState(function () {
        return {};
      });
  var sessions = match$7[0];
  var match$8 = React.useState(function () {
        return [];
      });
  var setPaymentOptions = match$8[1];
  var paymentOptions = match$8[0];
  var match$9 = React.useState(function () {
        return [];
      });
  var setWalletOptions = match$9[1];
  var walletOptions = match$9[0];
  var match$10 = React.useState(function () {
        return 0;
      });
  var cardsContainerWidth = match$10[0];
  var match$11 = React.useState(function () {
        return [];
      });
  var setDropDownOptions = match$11[1];
  var dropDownOptions = match$11[0];
  var match$12 = React.useState(function () {
        return [];
      });
  var setCardOptions = match$12[1];
  var cardOptions = match$12[0];
  var match$13 = React.useState(function () {
        return [];
      });
  var setSavedMethods = match$13[1];
  var savedMethods = match$13[0];
  var match$14 = React.useState(function () {
        return "LoadingSavedCards";
      });
  var setLoadSavedCards = match$14[1];
  var loadSavedCards = match$14[0];
  var match$15 = React.useState(function () {
        return false;
      });
  var setIsClickToPayAuthenticateError = match$15[1];
  var isClickToPayAuthenticateError = match$15[0];
  var match$16 = React.useState(function () {
        return false;
      });
  var areClickToPayUIScriptsLoaded = match$16[0];
  var isShowPaymentMethodsDependingOnClickToPay = React.useMemo((function () {
          if (Core__Option.getOr(clickToPayConfig.clickToPayCards, []).length > 0 || Core__Option.getOr(clickToPayConfig.isReady, false) && Core__Option.isNone(clickToPayConfig.clickToPayCards) || clickToPayConfig.email !== "") {
            return !isClickToPayAuthenticateError;
          } else {
            return false;
          }
        }), [
        clickToPayConfig,
        isClickToPayAuthenticateError
      ]);
  var layoutClass = CardUtils$OrcaPaymentPage.getLayoutClass(match.layout);
  var match$17 = layoutClass.savedMethodCustomization.groupingBehavior;
  var groupByPaymentMethods = match$17.groupByPaymentMethods;
  var displayInSeparateScreen = match$17.displayInSeparateScreen;
  var groupSavedMethodsWithPaymentMethods = !displayInSeparateScreen && groupByPaymentMethods;
  var groupSavedMethodsSeparately = !displayInSeparateScreen && !groupByPaymentMethods;
  var match$18 = ClickToPayHook$OrcaPaymentPage.useClickToPay(areClickToPayUIScriptsLoaded, match$7[1], match$16[1], savedMethods, loadSavedCards);
  var closeComponentIfSavedMethodsAreEmpty = match$18[1];
  var getVisaCards = match$18[0];
  React.useEffect((function () {
          if (displaySavedPaymentMethods) {
            if (typeof customerPaymentMethods === "object") {
              if (customerPaymentMethods.TAG === "LoadedSavedCards") {
                var isGuestCustomer = customerPaymentMethods._1;
                var displayDefaultSavedPaymentIcon = optionAtomValue.displayDefaultSavedPaymentIcon;
                var sortSavedPaymentMethods = function (a, b) {
                  var defaultCompareVal = Utils$OrcaPaymentPage.compareLogic(new Date(a.lastUsedAt), new Date(b.lastUsedAt));
                  if (displayDefaultSavedPaymentIcon) {
                    if (a.defaultPaymentMethodSet) {
                      return -1;
                    } else if (b.defaultPaymentMethodSet) {
                      return 1;
                    } else {
                      return defaultCompareVal;
                    }
                  } else {
                    return defaultCompareVal;
                  }
                };
                var finalSavedPaymentMethods = PaymentUtils$OrcaPaymentPage.filterSavedMethodsByWalletReadiness(PaymentUtils$OrcaPaymentPage.filterSavedMethodsByHiddenList(customerPaymentMethods._0.slice(), layoutClass.savedMethodCustomization.hiddenPaymentMethods), isApplePayReady, isGPayReady);
                finalSavedPaymentMethods.sort(sortSavedPaymentMethods);
                var paymentOrder = Utils$OrcaPaymentPage.removeDuplicate(Utils$OrcaPaymentPage.getOptionalArr(paymentMethodOrder));
                var sortSavedMethodsBasedOnPriority = PaymentUtils$OrcaPaymentPage.sortCustomerMethodsBasedOnPriority(finalSavedPaymentMethods, paymentOrder, displayDefaultSavedPaymentIcon);
                setSavedMethods(function (param) {
                      return sortSavedMethodsBasedOnPriority;
                    });
                setLoadSavedCards(function (param) {
                      if (finalSavedPaymentMethods.length === 0) {
                        return {
                                TAG: "NoResult",
                                _0: isGuestCustomer
                              };
                      } else {
                        return {
                                TAG: "LoadedSavedCards",
                                _0: finalSavedPaymentMethods,
                                _1: isGuestCustomer
                              };
                      }
                    });
                setShowPaymentMethodsScreen(function (param) {
                      if (finalSavedPaymentMethods.length === 0) {
                        return !isShowPaymentMethodsDependingOnClickToPay;
                      } else {
                        return false;
                      }
                    });
              } else {
                var isGuestCustomer$1 = customerPaymentMethods._0;
                setLoadSavedCards(function (param) {
                      return {
                              TAG: "NoResult",
                              _0: isGuestCustomer$1
                            };
                    });
                setShowPaymentMethodsScreen(function (param) {
                      return !isShowPaymentMethodsDependingOnClickToPay;
                    });
              }
            }
            
          } else {
            setShowPaymentMethodsScreen(function (param) {
                  return !isShowPaymentMethodsDependingOnClickToPay;
                });
            setLoadSavedCards(function (param) {
                  return {
                          TAG: "LoadedSavedCards",
                          _0: [],
                          _1: true
                        };
                });
          }
        }), [
        customerPaymentMethods,
        displaySavedPaymentMethods,
        optionAtomValue,
        isApplePayReady,
        isGPayReady,
        clickToPayConfig.isReady,
        isShowPaymentMethodsDependingOnClickToPay,
        layoutClass.savedMethodCustomization.hiddenPaymentMethods
      ]);
  React.useEffect((function () {
          var defaultSelectedPaymentMethod = optionAtomValue.displayDefaultSavedPaymentIcon ? savedMethods.find(function (savedMethod) {
                  return savedMethod.defaultPaymentMethodSet;
                }) : savedMethods[0];
          var isSavedMethodsEmpty = savedMethods.length === 0;
          var tokenObj = isSavedMethodsEmpty ? undefined : (
              defaultSelectedPaymentMethod !== undefined ? defaultSelectedPaymentMethod : Core__Option.getOr(savedMethods[0], PaymentType$OrcaPaymentPage.defaultCustomerMethods)
            );
          if (tokenObj !== undefined) {
            setPaymentToken(function (param) {
                  return {
                          paymentToken: tokenObj.paymentToken,
                          customerId: tokenObj.customerId
                        };
                });
          }
          
        }), [savedMethods]);
  var match$19 = PaymentUtils$OrcaPaymentPage.useGetPaymentMethodList(paymentType, sessions);
  var actualList = match$19[2];
  var paymentOptionsList = match$19[1];
  var walletList = match$19[0];
  var dict = Utils$OrcaPaymentPage.getDictFromJson(sessions);
  var sessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "Others");
  var applePaySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "ApplePayObject");
  var applePayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(applePaySessionObj.sessionsToken, "ApplePay");
  var gPayToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Gpay");
  var googlePayThirdPartySessionObj = SessionsType$OrcaPaymentPage.itemToObjMapper(dict, "GooglePayThirdPartyObject");
  var googlePayThirdPartyToken = SessionsType$OrcaPaymentPage.getPaymentSessionObj(googlePayThirdPartySessionObj.sessionsToken, "Gpay");
  var match$20 = PayPalHelpers$OrcaPaymentPage.usePaymentMethodData(paymentMethodListValue, sessionObj);
  var isPaypalRedirectFlow = match$20.isPaypalRedirectFlow;
  var paypalToken = match$20.paypalToken;
  var showAllPaymentMethods = layoutClass.paymentMethodsArrangementForTabs === "Grid";
  React.useEffect((function () {
          var exit = 0;
          if (typeof paymentMethodList !== "object") {
            if (paymentMethodList !== "Loading") {
              exit = 1;
            }
            
          } else if (paymentMethodList.TAG === "Loaded") {
            var pList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
            setPaymentOptions(function (param) {
                  return Utils$OrcaPaymentPage.removeDuplicate(Belt_Array.concatMany([
                                  Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder) ? ["card"] : [],
                                  paymentOptionsList
                                ]));
                });
            setWalletOptions(function (param) {
                  return walletList;
                });
            setPaymentMethodListValue(function (param) {
                  return pList;
                });
            if (!actualList.includes(selectedOption) && selectedOption !== "") {
              ErrorUtils$OrcaPaymentPage.manageErrorWarning("SDK_CONNECTOR_WARNING", "Please enable Card Payment in the dashboard, or 'ShowCard.FormByDefault' to false.", loggerState);
            } else if (!Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder)) {
              ErrorUtils$OrcaPaymentPage.manageErrorWarning("SDK_CONNECTOR_WARNING", "'paymentMethodOrder' is " + Utils$OrcaPaymentPage.getOptionalArr(paymentMethodOrder).join(", ") + " . Please enable Card Payment as 1st priority to show it as default.", loggerState);
            }
            
          } else {
            exit = 1;
          }
          if (exit === 1) {
            setPaymentOptions(function (param) {
                  if (Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder)) {
                    return ["card"];
                  } else {
                    return [];
                  }
                });
          }
          
        }), [
        paymentMethodList,
        walletList,
        paymentOptionsList,
        actualList
      ]);
  React.useEffect((function () {
          if (!showAllPaymentMethods && layoutClass.type === "Tabs") {
            var isCard = cardOptions.includes(selectedOption);
            if (!isCard) {
              var match = CardUtils$OrcaPaymentPage.swapCardOption(cardOptions, dropDownOptions, selectedOption);
              var dropdownArr = match[1];
              var cardArr = match[0];
              setCardOptions(function (param) {
                    return cardArr;
                  });
              setDropDownOptions(function (param) {
                    return dropdownArr;
                  });
            }
            
          }
          if (selectedOption !== "") {
            loggerState.setLogInfo("", "PAYMENT_METHOD_CHANGED", undefined, undefined, undefined, undefined, selectedOption.toUpperCase());
          }
          
        }), [
        selectedOption,
        cardOptions,
        dropDownOptions,
        showAllPaymentMethods,
        layoutClass
      ]);
  var isSelectedOptionValid = React.useMemo((function () {
          if (selectedOption !== "") {
            return paymentOptions.includes(selectedOption);
          } else {
            return false;
          }
        }), [
        paymentOptions,
        selectedOption
      ]);
  React.useEffect((function () {
          var cardsCount = cardsToRender(cardsContainerWidth);
          var cardOpts = paymentOptions.slice(0, cardsCount);
          var dropOpts = paymentOptions.slice(cardsCount);
          var isCard = cardOpts.includes(selectedOption);
          var shouldSwapSelectedOption = !isCard && isSelectedOptionValid && !showAllPaymentMethods;
          if (shouldSwapSelectedOption) {
            var match = CardUtils$OrcaPaymentPage.swapCardOption(cardOpts, dropOpts, selectedOption);
            var dropdownArr = match[1];
            var cardArr = match[0];
            setCardOptions(function (param) {
                  return cardArr;
                });
            setDropDownOptions(function (param) {
                  return dropdownArr;
                });
          } else if (showAllPaymentMethods) {
            setCardOptions(function (param) {
                  return paymentOptions;
                });
            setDropDownOptions(function (param) {
                  return [];
                });
          } else {
            setCardOptions(function (param) {
                  return cardOpts;
                });
            setDropDownOptions(function (param) {
                  return dropOpts;
                });
          }
        }), [
        cardsContainerWidth,
        paymentOptions
      ]);
  var cardShimmerCount = React.useMemo((function () {
          return cardsToRender(cardsContainerWidth);
        }), [cardsContainerWidth]);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && selectedOption === "") {
            return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", "Select a payment method");
          }
          
        }), [selectedOption]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  React.useEffect((function () {
          var shouldAutoOpenSavedMethods = !layoutClass.savedMethodCustomization.defaultCollapsed && groupSavedMethodsSeparately && paymentOptions.includes("saved_methods");
          setSelectedOption(function (prev) {
                if (prev !== "" && paymentOptions.includes(prev)) {
                  return prev;
                } else if (layoutClass.defaultCollapsed) {
                  if (shouldAutoOpenSavedMethods) {
                    return "saved_methods";
                  } else {
                    return "";
                  }
                } else if (typeof paymentMethodList !== "object") {
                  if (paymentMethodList === "Loading") {
                    return Core__Option.getOr(paymentOptions[0], "");
                  } else if (Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder)) {
                    return "card";
                  } else {
                    return "";
                  }
                } else if (paymentMethodList.TAG === "Loaded") {
                  if (paymentOptions.includes(selectedOption)) {
                    return selectedOption;
                  } else {
                    return Core__Option.getOr(paymentOptions[0], "");
                  }
                } else if (Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder)) {
                  return "card";
                } else {
                  return "";
                }
              });
        }), [
        layoutClass.defaultCollapsed,
        layoutClass.savedMethodCustomization.defaultCollapsed,
        groupSavedMethodsSeparately,
        paymentOptions,
        paymentMethodList,
        selectedOption
      ]);
  var match$21 = PaymentModeType$OrcaPaymentPage.paymentMode(selectedOption);
  var tmp;
  switch (match$21) {
    case "Card" :
        tmp = React.createElement(CardPayment$OrcaPaymentPage.make, {
              cardProps: cardProps,
              expiryProps: expiryProps,
              cvcProps: cvcProps
            });
        break;
    case "ACHTransfer" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(ACHBankTransferLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "ACHBankTransferLazy"
            });
        break;
    case "SepaTransfer" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(SepaBankTransferLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "SepaBankTransferLazy"
            });
        break;
    case "InstantTransfer" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(InstantBankTransferLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "InstantBankTransferLazy"
            });
        break;
    case "InstantTransferFinland" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(InstantBankTransferFinlandLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "InstantBankTransferFinlandLazy"
            });
        break;
    case "InstantTransferPoland" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(InstantBankTransferPolandLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "InstantBankTransferPolandLazy"
            });
        break;
    case "BacsTransfer" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(BacsBankTransferLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "BacsBankTransferLazy"
            });
        break;
    case "ACHBankDebit" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(ACHBankDebitLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "ACHBankDebitLazy"
            });
        break;
    case "SepaBankDebit" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(SepaBankDebitLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "SepaBankDebitLazy"
            });
        break;
    case "BacsBankDebit" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(BacsBankDebitLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "BacsBankDebitLazy"
            });
        break;
    case "BecsBankDebit" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(BecsBankDebitLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "BecsBankDebitLazy"
            });
        break;
    case "BanContactCard" :
        tmp = React.createElement(CardPayment$OrcaPaymentPage.make, {
              cardProps: cardProps,
              expiryProps: expiryProps,
              cvcProps: cvcProps,
              isBancontact: true
            });
        break;
    case "GooglePay" :
        var tmp$1;
        if (gPayToken.TAG === "OtherTokenOptional") {
          var optToken = gPayToken._0;
          var tmp$2;
          tmp$2 = googlePayThirdPartyToken.TAG === "GooglePayThirdPartyTokenOptional" ? React.createElement(GPayLazy$OrcaPaymentPage.make, {
                  sessionObj: optToken,
                  thirdPartySessionObj: googlePayThirdPartyToken._0,
                  walletOptions: walletOptions
                }) : React.createElement(GPayLazy$OrcaPaymentPage.make, {
                  sessionObj: optToken,
                  thirdPartySessionObj: undefined,
                  walletOptions: walletOptions
                });
          tmp$1 = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
                children: tmp$2,
                loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
                componentName: "GPayLazy"
              });
        } else {
          tmp$1 = null;
        }
        tmp = React.createElement(SessionPaymentWrapper$OrcaPaymentPage.make, {
              children: tmp$1,
              type_: "Wallet"
            });
        break;
    case "ApplePay" :
        tmp = applePayToken.TAG === "ApplePayTokenOptional" ? React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
                children: React.createElement(ApplePayLazy$OrcaPaymentPage.make, {
                      sessionObj: applePayToken._0,
                      walletOptions: walletOptions
                    }),
                loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
                componentName: "ApplePayLazy"
              }) : null;
        break;
    case "Boleto" :
        tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
              children: React.createElement(BoletoLazy$OrcaPaymentPage.make, {}),
              loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
              componentName: "BoletoLazy"
            });
        break;
    case "PayPal" :
        var tmp$3;
        if (paypalToken.TAG === "OtherTokenOptional") {
          var exit = 0;
          if (paypalToken._0 !== undefined && match$20.isPaypalSDKFlow) {
            loggerState.setLogInfo("PayPal Invoke SDK Flow in Tabs", "PAYPAL_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
            tmp$3 = null;
          } else {
            exit = 1;
          }
          if (exit === 1) {
            tmp$3 = isPaypalRedirectFlow ? React.createElement(PayPalLazy$OrcaPaymentPage.make, {
                    walletOptions: walletOptions
                  }) : null;
          }
          
        } else {
          tmp$3 = React.createElement(RenderIf$OrcaPaymentPage.make, {
                condition: isPaypalRedirectFlow,
                children: React.createElement(PayPalLazy$OrcaPaymentPage.make, {
                      walletOptions: walletOptions
                    })
              });
        }
        tmp = React.createElement(SessionPaymentWrapper$OrcaPaymentPage.make, {
              children: tmp$3,
              type_: "Wallet"
            });
        break;
    case "SavedMethods" :
        tmp = React.createElement(SavedMethods$OrcaPaymentPage.make, {
              paymentToken: paymentToken,
              setPaymentToken: setPaymentToken,
              savedMethods: savedMethods,
              loadSavedCards: loadSavedCards,
              cvcProps: cvcProps,
              sessions: sessions,
              isClickToPayAuthenticateError: isClickToPayAuthenticateError,
              setIsClickToPayAuthenticateError: setIsClickToPayAuthenticateError,
              getVisaCards: getVisaCards,
              closeComponentIfSavedMethodsAreEmpty: closeComponentIfSavedMethodsAreEmpty
            });
        break;
    default:
      tmp = React.createElement(ReusableReactSuspense$OrcaPaymentPage.make, {
            children: React.createElement(PaymentMethodsWrapperLazy$OrcaPaymentPage.make, {
                  paymentMethodName: selectedOption
                }),
            loaderComponent: React.createElement(LoaderPaymentShimmer$OrcaPaymentPage.make, {}),
            componentName: "PaymentMethodsWrapperLazy"
          });
  }
  var paymentFormElement = JsxPPXReactSupportU.createElementWithKey(selectedOption, ErrorBoundary$OrcaPaymentPage.make, {
        children: tmp,
        componentName: "PaymentElement",
        publishableKey: match$2.publishableKey
      });
  var checkoutEle = groupSavedMethodsWithPaymentMethods ? React.createElement(SavedMethodsWithPaymentForm$OrcaPaymentPage.make, {
          savedMethods: savedMethods,
          setPaymentToken: setPaymentToken,
          cvcProps: cvcProps,
          children: paymentFormElement,
          paymentToken: paymentToken,
          sessions: sessions,
          loadSavedCards: loadSavedCards,
          isClickToPayAuthenticateError: isClickToPayAuthenticateError,
          setIsClickToPayAuthenticateError: setIsClickToPayAuthenticateError,
          getVisaCards: getVisaCards,
          closeComponentIfSavedMethodsAreEmpty: closeComponentIfSavedMethodsAreEmpty,
          isShowPaymentMethodsDependingOnClickToPay: isShowPaymentMethodsDependingOnClickToPay
        }) : paymentFormElement;
  var paymentLabel = displaySavedPaymentMethods && !showPaymentMethodsScreen ? optionAtomValue.savedPaymentMethodsHeaderText : optionAtomValue.paymentMethodsHeaderText;
  React.useEffect((function () {
          if (groupSavedMethodsWithPaymentMethods || groupSavedMethodsSeparately) {
            setShowPaymentMethodsScreen(function (param) {
                  return true;
                });
          }
          var evalMethodsList = function () {
            if (typeof paymentMethodList !== "object" && paymentMethodList === "Loading") {
              return ;
            }
            Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                  [
                    "ready",
                    true
                  ],
                  [
                    "elementType",
                    CardThemeType$OrcaPaymentPage.getPaymentModeToString(paymentType)
                  ]
                ]);
          };
          if (displaySavedPaymentMethods) {
            if (typeof customerPaymentMethods === "object") {
              if (customerPaymentMethods.TAG === "LoadedSavedCards" && customerPaymentMethods._0.length > 0) {
                Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                      [
                        "ready",
                        true
                      ],
                      [
                        "elementType",
                        CardThemeType$OrcaPaymentPage.getPaymentModeToString(paymentType)
                      ]
                    ]);
              } else {
                evalMethodsList();
              }
            }
            
          } else {
            evalMethodsList();
          }
        }), [
        paymentMethodList,
        customerPaymentMethods
      ]);
  var shouldShowSavedMethods = displaySavedPaymentMethods || isShowPaymentMethodsDependingOnClickToPay;
  var shouldShowSavedMethodsScreen = !groupSavedMethodsWithPaymentMethods && !groupSavedMethodsSeparately && !showPaymentMethodsScreen && shouldShowSavedMethods;
  var hasSavedPaymentMethods = displaySavedPaymentMethods && savedMethods.length > 0;
  var shouldShowUseExistingMethodsButton = !groupSavedMethodsWithPaymentMethods && !groupSavedMethodsSeparately && (hasSavedPaymentMethods || isShowPaymentMethodsDependingOnClickToPay) && showPaymentMethodsScreen;
  var isLoadingGroupedSavedMethods = customerPaymentMethods === "LoadingSavedCards" && (groupSavedMethodsWithPaymentMethods || groupSavedMethodsSeparately);
  var hasPaymentOrWalletOptions = paymentOptions.length > 0 || walletOptions.length > 0;
  var shouldDisplayPaymentMethodsScreen = groupSavedMethodsWithPaymentMethods || groupSavedMethodsSeparately || showPaymentMethodsScreen;
  var shouldShowShimmer = Core__Option.isNone(clickToPayConfig.isReady) || isLoadingGroupedSavedMethods;
  var shouldRenderPaymentSection = !isLoadingGroupedSavedMethods && hasPaymentOrWalletOptions && shouldDisplayPaymentMethodsScreen && Core__Option.isSome(clickToPayConfig.isReady);
  var match$22 = layoutClass.type;
  var tmp$4;
  tmp$4 = match$22 === "Accordion" ? React.createElement(AccordionContainer$OrcaPaymentPage.make, {
          paymentOptions: paymentOptions,
          checkoutEle: checkoutEle,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        }) : React.createElement(PaymentOptions$OrcaPaymentPage.make, {
          setCardsContainerWidth: match$10[1],
          cardOptions: cardOptions,
          dropDownOptions: dropDownOptions,
          checkoutEle: checkoutEle,
          cardShimmerCount: cardShimmerCount,
          cardProps: cardProps,
          expiryProps: expiryProps,
          cvcProps: cvcProps
        });
  var tmp$5;
  var exit$1 = 0;
  if (typeof paymentMethodList !== "object" || paymentMethodList.TAG !== "LoadError") {
    exit$1 = 1;
  } else {
    tmp$5 = React.createElement(RenderIf$OrcaPaymentPage.make, {
          condition: paymentMethodListValue.payment_methods.length === 0,
          children: React.createElement(ErrorBoundary$OrcaPaymentPage.ErrorTextAndImage.make, {
                divRef: divRef,
                level: "Top"
              })
        });
  }
  if (exit$1 === 1) {
    tmp$5 = React.createElement(RenderIf$OrcaPaymentPage.make, {
          condition: !displaySavedPaymentMethods && paymentOptions.length === 0 && walletOptions.length === 0,
          children: React.createElement(PaymentElementShimmer$OrcaPaymentPage.make, {})
        });
  }
  return React.createElement(React.Fragment, {}, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: Core__Option.isSome(paymentLabel),
                  children: React.createElement("div", {
                        "aria-level": 1,
                        className: "PaymentLabel text-2xl font-semibold text-[#151619] mb-6",
                        role: "heading"
                      }, Core__Option.getOr(paymentLabel, ""))
                }), shouldShowShimmer ? (
                areClickToPayUIScriptsLoaded ? React.createElement((function (prim) {
                          return React.createElement("src-loader", prim);
                        }), {}) : (
                    groupSavedMethodsWithPaymentMethods || groupSavedMethodsSeparately ? React.createElement(PaymentElementShimmer$OrcaPaymentPage.make, {}) : React.createElement(PaymentElementShimmer$OrcaPaymentPage.SavedPaymentCardShimmer.make, {})
                  )
              ) : React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: shouldShowSavedMethodsScreen,
                    children: React.createElement(SavedMethods$OrcaPaymentPage.make, {
                          paymentToken: paymentToken,
                          setPaymentToken: setPaymentToken,
                          savedMethods: savedMethods,
                          loadSavedCards: loadSavedCards,
                          cvcProps: cvcProps,
                          sessions: sessions,
                          isClickToPayAuthenticateError: isClickToPayAuthenticateError,
                          setIsClickToPayAuthenticateError: setIsClickToPayAuthenticateError,
                          getVisaCards: getVisaCards,
                          closeComponentIfSavedMethodsAreEmpty: closeComponentIfSavedMethodsAreEmpty
                        })
                  }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: shouldRenderPaymentSection,
                  children: React.createElement("div", {
                        "aria-label": "Payment Section",
                        className: "flex flex-col place-items-center",
                        role: "region",
                        tabIndex: 0
                      }, JsxPPXReactSupportU.createElementWithKey("payment_request_buttons_all", ErrorBoundary$OrcaPaymentPage.make, {
                            children: React.createElement(PaymentRequestButtonElement$OrcaPaymentPage.make, {
                                  sessions: sessions,
                                  walletOptions: walletOptions
                                }),
                            level: "RequestButton",
                            componentName: "PaymentRequestButtonElement"
                          }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                            condition: paymentOptions.length > 0 && walletOptions.length > 0 && PaymentUtils$OrcaPaymentPage.checkRenderOrComp(walletOptions, isShowOrPayUsing, isShowOrPayUsingWhileLoading),
                            children: React.createElement(Or$OrcaPaymentPage.make, {
                                  separatorText: layoutClass.separatorText
                                })
                          }), tmp$4)
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: shouldShowUseExistingMethodsButton,
                  children: React.createElement(SwitchViewButton$OrcaPaymentPage.make, {
                        onClick: (function (param) {
                            setShowPaymentMethodsScreen(function (param) {
                                  return false;
                                });
                          }),
                        icon: React.createElement(Icon$OrcaPaymentPage.make, {
                              name: "circle_dots",
                              size: 20,
                              width: 19
                            }),
                        title: match$1.localeString.useExistingPaymentMethods,
                        ariaLabel: "Click to use existing payment methods",
                        onKeyDown: (function ($$event) {
                            var key = $$event.key;
                            var keyCode = $$event.keyCode;
                            if (key === "Enter" || keyCode === 13) {
                              return setShowPaymentMethodsScreen(function (param) {
                                          return false;
                                        });
                            }
                            
                          })
                      })
                }), tmp$5, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: match.sdkHandleConfirmPayment.handleConfirm,
                  children: React.createElement("div", {
                        className: "mt-4"
                      }, React.createElement(PayNowButton$OrcaPaymentPage.make, {}))
                }), React.createElement(PoweredBy$OrcaPaymentPage.make, {}));
}

var make = PaymentElement;

export {
  cardsToRender ,
  make ,
}
/* react Not a pure module */
